import { Files } from '../../lib/constants/files'
import { FileInput } from '../../lib/types/models/file/file-input'
import { HostFamily } from '../../lib/types/models/host-family/host-family'
import { HostFamilyRequest } from '../../lib/types/models/host-family/host-family-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createHostFamily(data: HostFamilyRequest) {
  const { picturesAndVideos, ...rest } = data
  let uploadedFiles: FileInput[] = []
  if (picturesAndVideos?.length) {
    uploadedFiles = (await Promise.all(
      picturesAndVideos.map((file) => (file ? uploadFile(Files.CENTER_EVENT_ACTION, file) : null))
    ).then((files) => files.filter((file) => file !== null))) as FileInput[]
  }
  return restApiClient
    .url(constructApiUrl(API.hostFamilies.create.url, null))
    .post<HostFamily, HostFamilyRequest>({ ...rest, picturesAndVideos: uploadedFiles })
}
